import { Report61Component } from "../../../components/SupportSystem/Reports/Report61Component";
// import { NavbarComponent } from "../../../components/share/NavbarComponent";
import { NavbarSupportSystem } from "../../../components/share/NavbarSupportSystem";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";


export function Report61Container() {
    const titleName = "รายงานการให้เงินช่วยเหลืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงาน";
    return(
        <div className="page-container bg-landing">
            <NavbarSupportSystem />
            <HeadTitle title={titleName} />
            <Report61Component/>
            <Footer />
        </div>   
        // 
    )
    
}